export class AuthentificationDto {
    public  ClientKey!: string;
    public  Email!: string;
    public  Password!: string;
}
